import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import installed from "../../../../images/notif-tones/MicrosoftTeams-image (3).png";
import getColors from "../../../../components/colors";
import dataLoadingIcon from "../../../../images/template-img/data-loading.png";
import walkthroughIcon from "../../../../images/template-img/walkthrough-icon.png";
import { DownloadOutlined } from "@ant-design/icons";
import { Dropdown, Space, Tooltip } from "antd";

import shareIcon from "../../../../images/shareIcon.png";
import facebook from "../../../../images/social/facebook.svg";
import twitter from "../../../../images/social/twitter.svg";
import linkedin from "../../../../images/social/linkedin.svg";
import thumbsUp from "../../../../images/thumbs-up.svg";
import thumbsDown from "../../../../images/thumbs-down.svg";
import userAvatar from "../../../../images/avatar.png";
import info from "../../../../images/info.png";

import { connect } from "react-redux";
import { withRouter } from "react-router";
import { compose } from "redux";
import { notify } from "../../../../redux/actions/snack";
import workFlowIcon from "../../../../images/template-img/workflow.png";
import {
  getSkillsFromStore,
  addSkillToUser,
  executeFlow,
  getSession,
  changeSkillAreaView,
  getDraftSkillsById,
  addSkillFromStore,
  rateSkill,
  addSkillSetFromStore,
  changeActiveTab,
  getSkillSet,
  checkAndOnboardAgent,
  getSkillStoreData,
} from "../../../../redux/actions/skill";
import webAutomationIcon from "../../../../images/template-img/web-automation.png";
import userOnboardingIcon from "../../../../images/template-img/user-onboarding.png";

import { Button, Modal, Input } from "antd";
import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
} from "react-share";
import $ from "jquery";
import { flexbox } from "@material-ui/system";
import skillSetImage from "../../../../images/SkillsetImage.png";
import Profile from "../../../../images/user.png";
import TextArea from "antd/lib/input/TextArea";

const TEMPLATE_WITH_LOOP_RESTRICTION = [
  "UserDocumentation",
  // "WebAutomation",
  "Desktop Walkthrough",
  "In-App Walkthrough",
  "UserOnboarding",
];
const SkillItem = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const skill = useSelector((state) => state.skillReducer);
  const user = useSelector((state) => state.userReducer?.user);
  const devices = useSelector((state) => state.skillReducer?.draftSession);

  const opt = props?.opt;
  const [item, setItem] = useState(props?.item);
  const [upVotes, setUpVotes] = useState(
    props?.item?.Rating?.upVote?.filter((i) => i == user?.sub)
  );
  const [downVotes, setDownVotes] = useState(
    props?.item?.Rating?.upVote?.filter((i) => i == user?.sub)
  );
  const [userComments, setUserComments] = useState(
    props?.item?.Rating?.comments
  );

  const [isAdding, setIsAdding] = useState(false);
  const [isOpen, setIsOpen] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [comments, setComments] = useState("");
  const [isPlaying, setIsPlaying] = useState(false);
  const shareUrl = `${process.env.REACT_APP_BOT_SERVICE_URL}/dashboard/skills/viewSkill/${item?.id}`;
  const items = [
    {
      label: (
        <FacebookShareButton
          url={shareUrl}
          quote={"abc"}
          hashtag={item?.SKILL_NAME}
          description={item?.SKILL_DESCRIPTION}
          className=""
        >
          <img src={facebook} />
        </FacebookShareButton>
      ),
      key: "0",
    },
    {
      label: (
        <TwitterShareButton
          url={shareUrl}
          title={item?.SKILL_NAME}
          className=""
        >
          <img src={twitter} />
        </TwitterShareButton>
      ),
      key: "1",
    },
    {
      label: (
        <LinkedinShareButton
          url={shareUrl}
          title={item?.SKILL_NAME}
          summary={item?.SKILL_DESCRIPTION}
          className=""
        >
          <img src={linkedin} />
        </LinkedinShareButton>
      ),
      key: "3",
    },
  ];

  useEffect(() => {
    window.$('[data-toggle="popover"]').popover({
      container: "body",
    });

    let colors = [
      "#f54747",
      "#8a5fff",
      "#ffa933",
      "#ff6233",
      "#1d262e",
      "#297bff",
      "#ff2963",
      "#21b8dd",
    ];
    let count = 0;

    $(".avatar-sk span").each(function () {
      $(this).css("background-color", colors[count]);
      count++;
      if (count === colors.length) {
        count = 0;
      }
    });
  }, []);

  const updateItemStatus = (id, type) => {
    if (type === "automation") {
      item.isAvailable = true;
      setItem(item);
    } else {
      item.isavailable = "1";
      setItem(item);
    }
  };

  const addToMySkills = async (skill) => {
    if (skill.TYPE === "SkillHub") {
      setIsAdding(true);

      let skillDetail = await dispatch(getDraftSkillsById(skill.id));

      if (
        skillDetail?.data?.data?.onboarding_url == false ||
        skillDetail?.data?.data?.onboarding_url == null
      ) {
        if (skillDetail?.data?.data?.TEMPLATE === "GenAi Automation") {
          let skill = {
            v2SkillId: skillDetail?.data?.data?.v2SkillId,
            v2AgentId: skillDetail?.data?.data?.v2AgentId,
            name: skillDetail?.data?.data?.SKILL_NAME,
            description: skillDetail?.data?.data?.SKILL_DESCRIPTION,
          };

          let res = await dispatch(checkAndOnboardAgent(skill));
         
          let onboardSkillInfo = {
            skillId: skillDetail?.data?.data?.id,
            skillMeta: {
              Type: "draft_skill",
              Template: skillDetail?.data?.data?.TEMPLATE,
              URL: "",
              v2AgentId: res?.data?.agentId,
              v2SkillId: res?.data?.automationId,
            },
            skillName: skillDetail?.data?.data?.SKILL_NAME,
          };
          await dispatch(addSkillFromStore(onboardSkillInfo));
        } else {
          let url;
          skillDetail?.data?.data?.FORMATED_DATA?.actions &&
            Object.values(
              skillDetail?.data?.data?.FORMATED_DATA?.actions
            ).forEach((s) => {
              if (s.type === "OPEN_WEB_PAGE") {
                url = s.url;
              }
            });
          let onboardSkillInfo = {
            skillId: skill.id,
            skillMeta: {
              Type: "draft_skill",
              Template: skillDetail?.data?.data?.TEMPLATE,
              URL: url,
            },
            skillName: skillDetail?.data?.data?.SKILL_NAME,
          };
          await dispatch(addSkillFromStore(onboardSkillInfo));
        }

        let data = { skillId: skill.id, type: "SkillHub" };
        updateItemStatus(data);
        dispatch(
          notify("success", "Agent added successfully. Go to 'AI Agents' Added From Agent Hub section")
        );
        dispatch(getSkillStoreData());

        setIsAdding(false);
        history.push(`/dashboard/skills/published`);
        dispatch(changeActiveTab("Added From Agent Hub"));
      } else {
        const skillTemp = { ...skill };
        skillTemp.metadata = {
          Type: "draft_skill",
          Template: skill["TEMPLATE"],
        };
        skillTemp.updateSkills = updateItemStatus;
        skillTemp.tags = [
          {
            skill_fields: [
              {
                field_name: "URL",
                field_type: "text",
                validation: "weburl",
              },
            ],
          },
        ];
        await dispatch(addSkillToUser(skillTemp));
        $("#flag").click();
        setIsAdding(false);

        // history.push(`/dashboard/skills/published`);
      }
    }
  };

  const addSkillSet = async (skill) => {
    setIsAdding(true);

    let _url;
    if (skill?.template) {
      let skillDetail = await dispatch(getSkillSet(skill.skillId));
      if (skill.onboarding_url == false || skill.onboarding_url == null) {
        skill.FORMATED_DATA?.actions &&
          Object.values(skill.FORMATED_DATA.actions).forEach((s) => {
            if (s.type === "OPEN_WEB_PAGE") {
              _url = s.url;
            }
          });

        let onboardSkillInfo = {
          skillId: skill.skillId,
          skillMeta: {
            Type: "SkillSet",
            Template: skill?.template,
            URL: _url,
            subTask: skillDetail[0]?.skills,
          },
          skillName: skill?.skillSetName,
        };
        await dispatch(addSkillFromStore(onboardSkillInfo));
        let data = { skillId: skill.skillId, type: "SkillSet" };
        updateItemStatus(data);
        dispatch(
          notify("success", "Agent added successfully. Go to 'AI Agents' Added From Agent Hub section")
        );
        setIsAdding(false);
        history.push(`/dashboard/skills/published`);
        dispatch(changeActiveTab("Added From Agent Hub"));
      } else {
        let skillTemp = { ...skill };
        skillTemp.metadata = {
          Type: "SkillSet",
          Template: skill?.template,
          subTask: skillDetail[0]?.skills,
        };
        skillTemp.updateSkills = updateItemStatus;
        skillTemp.tags = [
          {
            skill_fields: [
              {
                field_name: "URL",
                field_type: "text",
                validation: "weburl",
              },
            ],
          },
        ];
        await dispatch(addSkillToUser(skillTemp));
        $("#flag").click();

        setIsAdding(false);
      }
    } else {
      let skillDetail = await dispatch(getSkillSet(skill.id));
      if (skill.onboarding_url == false || skill.onboarding_url == null) {
        skill.FORMATED_DATA?.actions &&
          Object.values(skill.FORMATED_DATA.actions).forEach((s) => {
            if (s.type === "OPEN_WEB_PAGE") {
              _url = s.url;
            }
          });

        let onboardSkillInfo = {
          skillId: skill.id,
          skillMeta: {
            Type: "SkillSet",
            Template: skill?.TEMPLATE,
            URL: _url,
            subTask: skillDetail[0]?.skills,
          },
          skillName: skill?.SKILL_NAME,
        };
        await dispatch(addSkillFromStore(onboardSkillInfo));
        let data = { skillId: skill.id, type: "SkillSet" };
        updateItemStatus(data);
        dispatch(
          notify("success", "Agent added successfully. Go to 'AI Agents' Added From Agent Hub section")

        );
        setIsAdding(false);
        history.push(`/dashboard/skills/published`);
        dispatch(changeActiveTab("Added From Agent Hub"));
      } else {
        let skillTemp = { ...skill };
        skillTemp.metadata = {
          Type: "SkillSet",
          Template: skill?.TEMPLATE,
          subTask: skillDetail[0]?.skills,
        };
        skillTemp.updateSkills = updateItemStatus;
        skillTemp.tags = [
          {
            skill_fields: [
              {
                field_name: "URL",
                field_type: "text",
                validation: "weburl",
              },
            ],
          },
        ];
        await dispatch(addSkillToUser(skillTemp));
        $("#flag").click();

        setIsAdding(false);
      }
    }
  };

  const viewItem = async (viewItem) => {
    if (!(viewItem.TYPE === "automation")) {
    } else {
      if (!viewItem.isAvailable || !viewItem.isavailable) {
        dispatch(addSkillToUser(viewItem));
        $("#flag").click();
      }
    }
  };

  const shareRating = async (ratingData) => {
    let _skillData = item;
    let _payloadData;
    let _upVote = _skillData?.Rating?.upVote || [];
    let _downVote = _skillData?.Rating?.downVote || [];
    let _userComments = _skillData?.Rating?.comments || [];
    let _currentUser = user?.sub;

    let _checkLikeHistory = _upVote?.filter((i) => i == _currentUser);
    let _checkDisLikeHistory = _downVote?.filter((i) => i == _currentUser);

    if (ratingData === "upvote") {
      if (_checkLikeHistory?.length > 0) {
        let index = _upVote?.indexOf(_currentUser);
        if (index > -1) {
          _upVote?.splice(index, 1);
          setUpVotes(_upVote);
          _payloadData = {
            upVote: _upVote,
            downVote: _downVote,
            userComments: _userComments,
          };
        } else {
          if (_checkDisLikeHistory?.length > 0) {
            let index = _downVote?.indexOf(_currentUser);
            if (index > -1) {
              _downVote?.splice(index, 1);
              setDownVotes(_downVote);
            }
          }
          _upVote.push(`${_currentUser}`);

          _payloadData = {
            upVote: _upVote,
            downVote: _downVote,
            userComments: _userComments,
          };
        }
      } else {
        if (_checkDisLikeHistory?.length > 0) {
          let index = _downVote?.indexOf(_currentUser);
          if (index > -1) {
            _downVote?.splice(index, 1);
            setDownVotes(_downVote);
          }
        }
        _upVote.push(`${_currentUser}`);

        _payloadData = {
          upVote: _upVote,
          downVote: _downVote,
          userComments: _userComments,
        };
      }
      _skillData.Rating = _payloadData;
      const sendRating = await dispatch(
        rateSkill(item.id, {
          ..._skillData,
        })
      );
      setItem(_skillData);
    }

    // ========================================
    if (ratingData === "downvote") {
      if (
        _checkDisLikeHistory !== undefined &&
        _checkDisLikeHistory?.length > 0
      ) {
        const index = _downVote?.indexOf(_currentUser);
        if (index > -1) {
          _downVote?.splice(index, 1);
          setDownVotes(_downVote);
          setComments(_userComments);
          _payloadData = {
            upVote: _upVote,
            downVote: _downVote,
            userComments: _userComments,
          };
        } else {
          if (_checkLikeHistory?.length > 0) {
            let index = _upVote?.indexOf(_currentUser);
            if (index > -1) {
              _upVote?.splice(index, 1);
              setUpVotes(_upVote);
            }
          }
          _downVote.push(`${_currentUser}`);
          _userComments.push({
            userId: `${_currentUser}`,
            comments: comments,
          });
          _payloadData = {
            upVote: _upVote,
            downVote: _downVote,
            userComments: _userComments,
          };
        }
      } else {
        if (_checkLikeHistory?.length > 0) {
          let index = _upVote?.indexOf(_currentUser);
          if (index > -1) {
            _upVote?.splice(index, 1);
          }
        }
        _downVote.push(`${_currentUser}`);
        _userComments.push({
          userId: `${_currentUser}`,
          comments: comments,
        });
        _payloadData = {
          upVote: _upVote,
          downVote: _downVote,
          userComments: _userComments,
        };
      }
      _skillData.Rating = _payloadData;
      const sendRating = await dispatch(
        rateSkill(item.id, {
          ..._skillData,
        })
      );
      setItem(_skillData);
    }
  };
  const handleCancel = () => {
    setIsOpen(false);
    setComments("");
  };

  const handleOk = () => {
    shareRating("downvote");
    setIsOpen(false);
  };

  const removeHtmlTags = (html) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    return tempDiv.textContent || tempDiv.innerText || "";
  };

  const sanitizedDescription = removeHtmlTags(item.SKILL_DESCRIPTION);
  const sanitizedLongDescription = removeHtmlTags(item.longDescription);
  const displaySkillCard = () => {
    return (
      <div className="item sk-slide-item" onClick={() => viewItem(item)}>
        <div className="tpb-outer">
        {item?.subCategory?.length > 0 ?
          <span
            className="tlp-name"
            title={
              item?.subCategory? item?.subCategory : ""
            }
          >
              {item?.subCategory? item?.subCategory : ""}
          </span>:null}

          <div
            className="tlp-icon"
            style={{ padding: "0px" }}
            // onClick={() =>
            //   history.push(`/dashboard/skills/viewSkill/${item?.id}`)
            // }
          >
            <img
              src={
                item.TEMPLATE === "Import Data from Spreadsheet to Web App"
                  ? dataLoadingIcon
                  : item.TEMPLATE === "In-App Walkthrough"
                  ? walkthroughIcon
                  : item.TEMPLATE === "UserOnboarding"
                  ? userOnboardingIcon
                  : item.TEMPLATE === "WebAutomation"
                  ? webAutomationIcon
                  : item.TEMPLATE === "GenAi Automation"
                  ? workFlowIcon
                  : dataLoadingIcon
              }
              alt=""
            />
          </div>
          <div className="tp-content">
            <div className="tp-inner-content">
              <h5 className="tlp-title-in" title={item.SKILL_NAME}>
                {item.SKILL_NAME}
              </h5>
              <span className="tlp-text">
                <div className="overflow-text">
                  <div className="inner-text">
                    <div
                      className={
                        sanitizedDescription.includes("<ul>")
                          ? "inner-text-hidden"
                          : "inner-text-hidden"
                      }
                      dangerouslySetInnerHTML={{ __html: sanitizedDescription }}
                    ></div>

                    {/* <div
                      className={
                        sanitizedDescription.includes("<ul>") ? "inner-text-hidden" : "inner-text"
                      }
                      dangerouslySetInnerHTML={{ __html: sanitizedDescription.replace(/<p>/g, '').replace(/<\/p>/g, '') }}
                    ></div> */}
                    {item.SKILL_DESCRIPTION &&
                    item.SKILL_DESCRIPTION.length > 100 ? (
                      <>
                        <a
                          class="tlt-icon tl-tooltip"
                          href="javascript:void(0)"
                          data-toggle="popover"
                          data-html="true"
                          data-trigger="hover"
                          data-placement="auto right"
                          data-content={sanitizedDescription}
                          title="Description"
                        >
                          <img src={info} alt="" />
                        </a>
                      </>
                    ) : null}
                  </div>
                </div>
              </span>
              {item?.onBoardedCount ? (
                <Tooltip title="Downloaded" className="tooltip-download">
                <span className="download-count">
                  {/* {<DownloadOutlined />}  */}
                  {` ${item?.onBoardedCount}`}
                </span>
                </Tooltip>
              ) : null}
            </div>
            { parseInt(item.isAvailable) ? (
              <div className="use-now">
                <div className="use-now-installed">
                  <div className="install-ico">
                    <img style={{ width: "15px" }} src={installed} alt="" />
                  </div>
                  <p style={{ fontStyle: "italic" }}> Added To AI Agents</p>
                </div>
                <div className="d-flex right-btns">
                  <button
                    className={` ${
                      upVotes?.length > 0 ? "thumbs liked" : "thumbs"
                    }`}
                    onClick={() => {
                      shareRating("upvote");
                    }}
                  >
                    <img src={thumbsUp} />
                    {item?.Rating?.upVote?.length > 0 ? (
                      <div class="badge badge-success">
                        {item?.Rating?.upVote?.length}
                      </div>
                    ) : null}
                  </button>

                  <button
                    className={` ${
                      downVotes?.length > 0 ? "thumbs dislike" : "thumbs"
                    }`}
                    onClick={() => {
                      setIsOpen(true);
                    }}
                  >
                    <img src={thumbsDown} />
                    {item?.Rating?.downVote?.length > 0 ? (
                      <div class="badge badge-danger">
                        {item?.Rating?.downVote?.length}
                      </div>
                    ) : null}
                  </button>

                  <div className="dropdown ss-shareIco">
                    <Dropdown
                      className="share-skill"
                      arrow={{ pointAtCenter: true }}
                      menu={{
                        items,
                      }}
                      trigger={["click"]}
                    >
                      <a onClick={(e) => e.preventDefault()}>
                        <Space>
                          <img src={shareIcon} />
                        </Space>
                      </a>
                    </Dropdown>
                  </div>
                  <div className="avatar-sk-icon">
                    <button className="avatar-sk">
                      {/* {item.profile_picture == "" ||
                      item.profile_picture == null ? (
                        <img src={userAvatar} />
                      ) : (
                        <img src={item.profile_picture} />
                      )} */}
                      <span>{item?.USER_EMAIL.substring(0, 2)}</span>
                    </button>
                    <span className="avatar-email">
                      {item?.first_name
                        ? item.first_name + " " + item.last_name
                        : item.USER_EMAIL}
                    </span>
                  </div>
                </div>
              </div>
            ) : (
              <>
                {isPlaying ? (
                  <button className="btn btn-default">
                    <div className="sp sp-circle text-light"></div>
                  </button>
                ) : opt && item.TYPE === "SkillHub" ? (
                  <div className="use-now">
                    <button
                      className="btn btn-default use-button"
                      onClick={(e) => {
                        addToMySkills(item);
                      }}
                    >
                      {isAdding ? (
                        <div className="sp sp-circle text-light"></div>
                      ) : (
                        "Add To AI Agents"
                      )}
                    </button>
                    <div className="d-flex right-btns">
                      <button
                        className={` ${
                          upVotes?.length > 0 ? "thumbs liked" : "thumbs"
                        }`}
                        onClick={() => {
                          shareRating("upvote");
                        }}
                      >
                        <img src={thumbsUp} />
                        {item?.Rating?.upVote?.length > 0 ? (
                          <div class="badge badge-success">
                            {item?.Rating?.upVote?.length}
                          </div>
                        ) : null}
                      </button>

                      <button
                        className={` ${
                          downVotes?.length > 0 ? "thumbs dislike" : "thumbs"
                        }`}
                        onClick={() => {
                          setIsOpen(true);
                        }}
                      >
                        {" "}
                        <img src={thumbsDown} />
                        {item?.Rating?.downVote?.length > 0 ? (
                          <div class="badge badge-danger">
                            {item?.Rating?.downVote?.length}
                          </div>
                        ) : null}
                      </button>
                      <div className="dropdown ss-shareIco">
                        <Dropdown
                          className="share-skill"
                          arrow={{ pointAtCenter: true }}
                          menu={{
                            items,
                          }}
                          trigger={["click"]}
                        >
                          <a onClick={(e) => e.preventDefault()}>
                            <Space>
                              <img src={shareIcon} />
                            </Space>
                          </a>
                        </Dropdown>
                      </div>
                      <div className="avatar-sk-icon">
                        <button className="avatar-sk">
                          {/* {item.profile_picture == "" ||
                          item.profile_picture == null ? (
                            <img src={userAvatar} />
                          ) : (
                            <img src={item.profile_picture} />
                          )} */}
                          <span>{item?.USER_EMAIL.substring(0, 2)}</span>
                        </button>
                        <span className="avatar-email">
                          {item?.first_name
                            ? item.first_name + " " + item.last_name
                            : item.USER_EMAIL}{" "}
                        </span>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="use-now centered-btns">
                    <button
                      onClick={(e) => {
                        addToMySkills(item);
                      }}
                      className="btn btn-default use-button"
                    >
                      {isAdding ? (
                        <div className="sp sp-circle text-light"></div>
                      ) : (
                        "Add To AI Agents"
                      )}
                    </button>
                    <div className="d-flex right-btns">
                      <button
                        className="thumbs"
                        onClick={() => {
                          shareRating("upvote");
                        }}
                      >
                        {" "}
                        <img src={thumbsUp} />
                        {item?.Rating?.upVote?.length > 0 ? (
                          <div class="badge badge-success">
                            {item?.Rating?.upVote?.length}
                          </div>
                        ) : null}
                      </button>

                      <button
                        className="thumbs"
                        onClick={() => {
                          setIsOpen(true);
                        }}
                      >
                        {" "}
                        <img src={thumbsDown} />
                        {item?.Rating?.downVote?.length > 0 ? (
                          <div class="badge badge-danger">
                            {item?.Rating?.downVote?.length}
                          </div>
                        ) : null}
                      </button>

                      <div className="dropdown ss-shareIco">
                        <Dropdown
                          className="share-skill"
                          arrow={{ pointAtCenter: true }}
                          menu={{
                            items,
                          }}
                          trigger={["click"]}
                        >
                          <a onClick={(e) => e.preventDefault()}>
                            <Space>
                              <img src={shareIcon} />
                            </Space>
                          </a>
                        </Dropdown>
                      </div>

                      <div className="avatar-sk-icon">
                        <button className="avatar-sk">
                          {/* {item.profile_picture == "" ||
                          item.profile_picture == null ? (
                            <img src={userAvatar} />
                          ) : (
                            <img src={item.profile_picture} />
                          )} */}
                          <span>{item?.USER_EMAIL.substring(0, 2)}</span>
                        </button>
                        <span className="avatar-email">
                          {item?.first_name
                            ? item.first_name + " " + item.last_name
                            : item.USER_EMAIL}{" "}
                        </span>
                      </div>
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    );
  };

  const checkDisplay = (item) => {
    if (item?.template == "Skill Set" || item.TEMPLATE == "Skill Set") {
      return displaySkillSets();
    } else {
      return displaySkillCard();
    }
  };

  // const hasTags = /<[a-z][\s\S]*>/i.test(item.longDescription);
  // const containsPTagInUL = /<ul[\s\S]*>[\s\S]*<p[\s\S]*>[\s\S]*<\/p>[\s\S]*<\/ul>/i.test(item.longDescription);

  const displaySkillSets = () => {
    return (
      <div
        className="item sk-slide-item"
        onClick={(e) => {
          e.stopPropagation();
          viewItem(item);
          history.push(
            `/dashboard/skill-store/skill/${
              item.skillId ? item.skillId : item.id
            }`
          );
        }}
      >
        <div className="tpb-outer">
          <div className="tlp-icon" style={{ padding: "0px" }}>
            <img src={skillSetImage} alt="" />
          </div>

          <div className="tp-content">
            <div className="tp-inner-content">
              <h5
                className="tlp-title-in"
                title={item?.skillSetName ? item.skillSetName : item.SKILL_NAME}
              >
                {item?.skillSetName ? item.skillSetName : item.SKILL_NAME}
              </h5>
              <span
                className="tlp-text"
                title={
                  item.longDescription ? (
                    <div
                      className={
                        item.longDescription.includes("<ul>")
                          ? "inner-text-hidden"
                          : "inner-text-hidden"
                      }
                      dangerouslySetInnerHTML={{
                        __html: sanitizedLongDescription,
                      }}
                    ></div>
                  ) : (
                    ""
                  )
                }
              >
                <div className="overflow-text">
                  <div
                    className={
                      sanitizedLongDescription.includes("<ul>")
                        ? "inner-text"
                        : "inner-text"
                    }
                  >
                    {item.longDescription ? (
                      <div
                        className="inner-text-hidden"
                        dangerouslySetInnerHTML={{
                          __html: sanitizedLongDescription,
                        }}
                      ></div>
                    ) : (
                      ""
                    )}
                    {item.longDescription &&
                    item.longDescription.length > 100 ? (
                      <>
                        <a
                          class="tlt-icon tl-tooltip"
                          href="javascript:void(0)"
                          data-toggle="popover"
                          data-html="true"
                          data-trigger="hover"
                          data-placement="auto right"
                          data-content={sanitizedLongDescription}
                          title="Description"
                        >
                          <img src={info} alt="" />
                        </a>
                      </>
                    ) : null}
                  </div>
                </div>
              </span>

              {item?.onboardedcount ? (
                <Tooltip title="Downloaded" className="tooltip-download">
                  <span className="download-count">
                    {/* {<DownloadOutlined />}  */}
                    {` ${item?.onboardedcount}`}
                  </span>
                </Tooltip>
              ) : null}
            </div>
            <div className="use-now">
              {item.isavailable == "1" ? (
                <>
                  <div className="install-ico">
                    <img style={{ width: "15px" }} src={installed} alt="" />
                  </div>
                  <p style={{ fontStyle: "italic" }}> Added To AI Agents</p>
                </>
              ) : (
                <button
                  className="btn btn-default use-button"
                  onClick={(e) => {
                    e.stopPropagation();
                    addSkillSet(item);
                  }}
                >
                  {isAdding ? (
                    <div className="sp sp-circle text-light"></div>
                  ) : (
                    "Add To AI Agents"
                  )}
                </button>
              )}

              <div className="d-flex right-btns">
                <button
                  className={` ${
                    upVotes?.length > 0 ? "thumbs liked" : "thumbs"
                  }`}
                  onClick={() => {
                    shareRating("upvote");
                  }}
                >
                  <img src={thumbsUp} />
                  {item?.Rating?.upVote?.length > 0 ? (
                    <div class="badge badge-success">
                      {item?.Rating?.upVote?.length}
                    </div>
                  ) : null}
                </button>

                <button
                  className={` ${
                    downVotes?.length > 0 ? "thumbs dislike" : "thumbs"
                  }`}
                  onClick={() => {
                    setIsOpen(true);
                  }}
                >
                  <img src={thumbsDown} />
                  {item?.Rating?.downVote?.length > 0 ? (
                    <div class="badge badge-danger">
                      {item?.Rating?.downVote?.length}
                    </div>
                  ) : null}
                </button>

                <div className="dropdown ss-shareIco">
                  <Dropdown
                    className="share-skill"
                    arrow={{ pointAtCenter: true }}
                    menu={{
                      items,
                    }}
                    trigger={["click"]}
                  >
                    <a onClick={(e) => e.preventDefault()}>
                      <Space>
                        <img src={shareIcon} />
                      </Space>
                    </a>
                  </Dropdown>
                </div>
                <div className="avatar-sk-icon">
                  <button className="avatar-sk">
                    {/* {item?.authInfo?.profile_picture == "" ||
                    item.profile_picture == null ? (
                      <img src={userAvatar} />
                    ) : (
                      <img src={item?.authInfo?.profile_picture} />
                    )} */}
                    <span>{item?.USER_EMAIL.substring(0, 2)}</span>
                  </button>
                  <span className="avatar-email">
                    {item?.authInfo?.firstName
                      ? item?.authInfo?.firstName +
                        " " +
                        item?.authInfo?.lastName
                      : item.USER_EMAIL}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const play = async (data) => {
    setIsPlaying(true);
    if (devices) {
      const playSkill = await dispatch(executeFlow(data));

      setIsPlaying(false);

      return;
    } else {
      dispatch(
        notify(
          "error",
          "You are not connected to Super Assistant. Please install Super Assistant app."
        )
      );
      setIsPlaying(false);
    }
  };

  return (
    <>
      <div>
        <button
          id="flag"
          data-toggle="modal"
          data-target="#myModal"
          style={{ display: "none" }}
        ></button>
        {checkDisplay(item)}
      </div>
      <Modal
        title="Submit Feedback"
        open={isOpen}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <TextArea
          onChange={(e) => {
            setComments(e.target.value);
          }}
        />
      </Modal>{" "}
    </>
  );
};
export default SkillItem;
